// Brand mark — same SVG as the marketing site (VietSurvive-WEB/index.html).
// Use the `size` prop for different contexts (header: 32, hero: 56).

interface LogoProps {
  size?: number;
  className?: string;
  ariaLabel?: string;
}

export function Logo({ size = 32, className, ariaLabel }: LogoProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role={ariaLabel ? 'img' : 'presentation'}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="14" fill="var(--brand)" />
      <path
        d="M18 18 L32 46 L46 18"
        stroke="#fff"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
